import classes from "./index.module.scss";
import Text from "../../../components/commons/Text";
import titleClasses from "../../../components/commons/HeroTitle.module.scss";
import { ReactComponent as Image } from "../images/hero.svg";
export default function Hero() {
  return (
    <section className={classes.section}>
      <div className={classes.container}>
        <div className={classes.body}>
          <div className={classes.content}>
            <h1 className={`${classes.title} ${titleClasses.title}`}>Events</h1>
            <Text
              className={classes.text}
              text={[
                `
                Our robo-devs not only strive to have a look into yet unexplored spaces of devolpment and automation, but are also extremly successful at analysing and organizing everything they have learned through these types of journeys. `,
                `
We are always set to share our knowledge with others as we strongly believe that it is the only way to truly evolve as a specialist. `,
                `
Join us on our regular events and webinars, learn and start your own journey into unexplored spaces of development universe!`,
              ]}
            />
          </div>
          <Image />
        </div>
      </div>
    </section>
  );
}
